export default "__VITE_ASSET__CT4geh3O__"